export default "__VITE_ASSET__DlzrWvTN__"